/** Pharmacy / chemist stock categories (Tanzania). Mirrors backend config/pharmacy.php */

export const PHARMACY_EXPIRY_REQUIRED_CATEGORIES = [
  'Tablets & capsules (Rx)',
  'Tablets & capsules (OTC)',
  'Syrups & suspensions',
  'Injections & vaccines',
  'Creams, ointments & gels',
  'Drops (eye / ear / nose)',
  'Inhalers & nebuliser supplies',
  'Family planning & contraceptives',
  'Vitamins & supplements',
];

export const PHARMACY_STOCK_CATEGORIES = [
  'Tablets & capsules (Rx)',
  'Tablets & capsules (OTC)',
  'Syrups & suspensions',
  'Injections & vaccines',
  'Creams, ointments & gels',
  'Drops (eye / ear / nose)',
  'Inhalers & nebuliser supplies',
  'Family planning & contraceptives',
  'Vitamins & supplements',
  'First aid & wound care',
  'Baby care (diapers, formula)',
  'Personal care & hygiene',
  'Medical devices (BP, thermometer)',
  'Surgical & clinic supplies',
  'Other',
];

/** @returns {{ value: string, label: string }[]} */
export function pharmacyCategorySelectOptions() {
  return [{ value: '', label: 'Select category…' }, ...PHARMACY_STOCK_CATEGORIES.map((c) => ({ value: c, label: c }))];
}

/** @param {{ category?: string }[]} products */
export function mergedPharmacyCategories(products) {
  const fromDb = Array.from(
    new Set((products || []).map((p) => (p.category || '').trim()).filter(Boolean))
  );
  const catalog = new Set(PHARMACY_STOCK_CATEGORIES);
  const extras = fromDb.filter((c) => !catalog.has(c));
  return [...PHARMACY_STOCK_CATEGORIES, ...extras].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

/** @param {string|null|undefined} expiryDate YYYY-MM-DD */
export function pharmacyExpiryStatus(expiryDate) {
  if (!expiryDate || typeof expiryDate !== 'string') return 'none';
  const d = new Date(`${expiryDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return 'none';
  const today = new Date();
  today.setHours(12, 0, 0, 0);
  const diffDays = Math.floor((d - today) / 86400000);
  if (diffDays < 0) return 'expired';
  if (diffDays <= 30) return 'soon';
  return 'ok';
}

/** @param {{ expiryDate?: string|null }[]} products */
export function pharmacyCategoryRequiresExpiry(category) {
  const cat = String(category || '').trim();
  if (!cat) return true;
  return PHARMACY_EXPIRY_REQUIRED_CATEGORIES.includes(cat);
}

export function todayDateInputValue() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function countPharmacyExpiryAlerts(products) {
  let expired = 0;
  let soon = 0;
  for (const p of products || []) {
    if (Array.isArray(p.batches) && p.batches.length) {
      for (const b of p.batches) {
        const q = Number(b.quantity) || 0;
        if (b.expiryStatus === 'expired') expired += q;
        else if (b.expiryStatus === 'soon') soon += q;
      }
    } else {
      const st = pharmacyExpiryStatus(p.expiryDate);
      const q = Number(p.quantity) || 1;
      if (st === 'expired') expired += q;
      else if (st === 'soon') soon += q;
    }
  }
  return { expired, soon, total: expired + soon };
}
